;(function () {
  'use strict'

  /* ─── IDs ─────────────────────────────────────────────────────── */
  var OVERLAY_ID = 'UpsellQvOverlay'
  var DRAWER_ID = 'UpsellQvDrawer'
  var HEADER_ID = 'UpsellQvHeader'
  var HEADER_TITLE_ID = 'UpsellQvHeaderTitle'
  var CLOSE_BTN_ID = 'UpsellQvClose'
  var BODY_ID = 'UpsellQvBody'
  var LOADING_ID = 'UpsellQvLoading'
  var SPINNER_ID = 'UpsellQvSpinner'
  var ERROR_ID = 'UpsellQvError'
  var ERROR_LINK_ID = 'UpsellQvErrorLink'

  var ATTR_BODY_SCROLL_LOCK = 'data-upsell-qv-scroll-lock'
  var ATTR_PAGE_OPEN = 'data-upsell-qv-open'

  /* Line item properties on /cart/add.js — visible on order line items in Admin (Flow, exports). */
  var CART_LINE_PROPERTIES_UPSELL_DRAWER = {
    _added_from_location: 'upsell_quick_view'
  }

  /* ─── State ───────────────────────────────────────────────────── */
  var overlay, drawer, headerTitle, closeBtn, drawerBody
  var swiperMain = null
  var swiperThumbs = null
  var closeTimer = null
  var animTimer = null
  var fetchAbortCtrl = null   // aborts in-flight quick-view + PDP fetches on rapid re-opens
  var swatchFetchId = 0       // incremented each swatch click; stale responses are dropped
  var qvLoadToken = 0         // bumps each fetchAndShow — ignore stale responses when opening another product
  var addonDiscountType = ''  // discount type from the bundle trigger (':percent' or ':dollar')
  var addonDiscountAmount = 0 // discount amount from the bundle trigger (percent value or cents)

  /* ─── Inject drawer HTML once ─────────────────────────────────── */
  function injectDrawer() {
    if (document.getElementById(DRAWER_ID)) {
      cacheElements()
      return
    }

    var overlayEl = document.createElement('div')
    overlayEl.id = OVERLAY_ID

    var panelEl = document.createElement('div')
    panelEl.id = DRAWER_ID
    panelEl.setAttribute('role', 'dialog')
    panelEl.setAttribute('aria-modal', 'true')
    panelEl.setAttribute('aria-labelledby', HEADER_TITLE_ID)

    panelEl.innerHTML =
      '<div id="' + HEADER_ID + '">' +
      '<p id="' + HEADER_TITLE_ID + '"></p>' +
      '<button id="' + CLOSE_BTN_ID + '" type="button" aria-label="Close">' +
      '<svg fill="none" stroke-width="2" focusable="false" width="22" height="22" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor"></path></svg>' +
      '</button>' +
      '</div>' +
      '<div id="' + BODY_ID + '"></div>'

    document.body.appendChild(overlayEl)
    document.body.appendChild(panelEl)

    cacheElements()
    bindDrawerEvents()
  }

  function cacheElements() {
    overlay = document.getElementById(OVERLAY_ID)
    drawer = document.getElementById(DRAWER_ID)
    headerTitle = document.getElementById(HEADER_TITLE_ID)
    closeBtn = document.getElementById(CLOSE_BTN_ID)
    drawerBody = document.getElementById(BODY_ID)
  }

  /** True while the panel is open for interaction — false during close animation or when shut. */
  function drawerAcceptsInjectedContent() {
    return !!(
      drawer &&
      drawerBody &&
      drawer.classList.contains('active') &&
      !drawer.classList.contains('closing')
    )
  }

  /* ─── Drawer open / close ─────────────────────────────────────── */
  function bindDrawerEvents() {
    overlay.addEventListener('click', closeDrawer)
    closeBtn.addEventListener('click', closeDrawer)
    document.addEventListener('keyup', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('active')) closeDrawer()
    })
    setupSwipeToClose()
  }

  function openDrawer(title) {
    if (!drawer || !drawerBody) return
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null }
    drawer.classList.remove('closing')
    if (title && headerTitle) headerTitle.textContent = title
    drawerBody.setAttribute(ATTR_BODY_SCROLL_LOCK, '')
    if (animTimer) clearTimeout(animTimer)
    animTimer = setTimeout(function () {
      drawerBody.removeAttribute(ATTR_BODY_SCROLL_LOCK)
      animTimer = null
    }, 280)
    overlay.classList.add('active')
    drawer.classList.add('active')
    document.body.setAttribute(ATTR_PAGE_OPEN, '')
  }

  function closeDrawer() {
    if (closeTimer) return
    if (!drawer || !drawerBody) return
    if (animTimer) { clearTimeout(animTimer); animTimer = null }
    drawerBody.setAttribute(ATTR_BODY_SCROLL_LOCK, '')
    drawer.classList.add('closing')
    closeTimer = setTimeout(function () {
      drawer.classList.remove('active', 'closing')
      overlay.classList.remove('active')
      document.body.removeAttribute(ATTR_PAGE_OPEN)
      drawerBody.removeAttribute(ATTR_BODY_SCROLL_LOCK)
      closeTimer = null
      destroySwipers()
    }, 220)
  }

  /* ─── Loading state ───────────────────────────────────────────── */
  function showLoading(title) {
    if (!drawerBody) return
    if (headerTitle) headerTitle.textContent = title || ''
    drawerBody.innerHTML =
      '<div id="' + LOADING_ID + '">' +
      '<div id="' + SPINNER_ID + '"></div>' +
      '</div>'
  }

  /* ─── Fetch + initial render ──────────────────────────────────── */
  function fetchAndShow(handle, variantId, productTitle) {
    var myLoadToken = ++qvLoadToken

    // Abort any in-flight fetch from a previous popup open
    if (fetchAbortCtrl) {
      fetchAbortCtrl.abort()
      fetchAbortCtrl = null
    }
    if (typeof AbortController !== 'undefined') {
      fetchAbortCtrl = new AbortController()
    }
    var signal = fetchAbortCtrl ? fetchAbortCtrl.signal : undefined

    openDrawer(productTitle)
    showLoading(productTitle)

    var qvUrl = '/products/' + handle + '?view=quick-view' + (variantId ? '&variant=' + variantId : '')
    var pdpUrl = '/products/' + handle + (variantId ? '?variant=' + variantId : '')

    /* Quick-view HTML is small/fast; full PDP is heavier (shipping estimator, section HTML).
       Show gallery + swatches as soon as quick-view returns; stream in PDP blocks when ready. */
    var pendingPdpHtml = null
    var qvInjected = false

    var DEFERRED_WRAPPER_IDS = ['UpsellQvAccordionWrapper', 'UpsellQvPriceWrapper', 'UpsellQvShippingWrapper']

    function clearDeferredPendingClasses() {
      if (!drawerBody) return
      DEFERRED_WRAPPER_IDS.forEach(function (id) {
        var el = drawerBody.querySelector('#' + id)
        if (el) el.classList.remove('upsell-qv-deferred-pending')
      })
    }

    function markDeferredPendingClasses() {
      if (!drawerBody) return
      DEFERRED_WRAPPER_IDS.forEach(function (id) {
        var el = drawerBody.querySelector('#' + id)
        if (el) el.classList.add('upsell-qv-deferred-pending')
      })
    }

    function tryInjectPdpBlocks() {
      if (myLoadToken !== qvLoadToken) return
      if (!drawerAcceptsInjectedContent()) return
      if (!qvInjected || !pendingPdpHtml) return
      var parser = new DOMParser()
      var doc = parser.parseFromString(pendingPdpHtml, 'text/html')
      injectBlocksFromDoc(doc, true)
      pendingPdpHtml = null
      clearDeferredPendingClasses()
    }

    function applyQuickViewShell(qvHtml) {
      if (myLoadToken !== qvLoadToken) return
      if (!drawerAcceptsInjectedContent()) return

      drawerBody.innerHTML = qvHtml
      injectAddonDiscountPrice()
      markDeferredPendingClasses()

      var titleEl = drawerBody.querySelector('.upsell-qv-title')
      if (titleEl && headerTitle) headerTitle.textContent = titleEl.textContent.trim()

      var qvEl = drawerBody.querySelector('.upsell-quick-view')
      var currentVariantId = qvEl ? qvEl.dataset.variantId : variantId
      switchGallery(currentVariantId)
      recalcSwatchAvailability()
      bindSwatchClicks()
      bindAddToCart()

      qvInjected = true
      tryInjectPdpBlocks()
    }

    fetch(qvUrl, signal ? { signal: signal } : {})
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status)
        return r.text()
      })
      .then(function (qvHtml) {
        if (myLoadToken !== qvLoadToken) return
        applyQuickViewShell(qvHtml)
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return
        if (myLoadToken !== qvLoadToken) return
        if (!drawerAcceptsInjectedContent()) return
        console.error('[upsell-quick-view] quick-view fetch error:', err)
        drawerBody.innerHTML =
          '<div id="' + ERROR_ID + '">Could not load product details. ' +
          '<a id="' + ERROR_LINK_ID + '" href="/products/' + handle + '">View product page →</a></div>'
      })

    fetch(pdpUrl, signal ? { signal: signal } : {})
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status)
        return r.text()
      })
      .then(function (html) {
        if (myLoadToken !== qvLoadToken) return
        pendingPdpHtml = html
        tryInjectPdpBlocks()
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return
        if (myLoadToken !== qvLoadToken) return
        if (drawerAcceptsInjectedContent() && qvInjected) {
          console.warn('[upsell-quick-view] product page fetch failed (price/shipping/accordion may be empty):', err)
          clearDeferredPendingClasses()
        }
      })
  }

  /* ─── Re-execute <script> tags injected via innerHTML ─────────────── */
  function runScripts(container) {
    container.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script')
      // Scripts that use DOMContentLoaded won't fire again — swap to setTimeout
      newScript.textContent = oldScript.textContent.replace(
        /document\.addEventListener\s*\(\s*['"]DOMContentLoaded['"]\s*,\s*/g,
        'setTimeout('
      )
      document.head.appendChild(newScript)
      newScript.parentNode.removeChild(newScript)
    })
  }

  /* ─── Format a cent amount using the page's existing addons-quantity formatter ── */
  function formatCents(cents) {
    var addonsQty = document.querySelector('addons-quantity')
    if (addonsQty && typeof addonsQty.formatPrice === 'function') {
      return addonsQty.formatPrice(cents / 100)
    }
    // Fallback: use Shopify money_format from theme.liquid
    var fmt = (window.cartStrings && window.cartStrings.money_format) || '${{amount}}'
    var amount = (cents / 100)
    var noDecimals = Math.round(amount)
    return fmt
      .replace('{{amount_no_decimals}}', noDecimals.toLocaleString())
      .replace('{{amount}}', amount % 1 === 0 ? noDecimals.toLocaleString() : amount.toFixed(2))
      .replace('{{amount_with_comma_separator}}', amount.toFixed(2).replace('.', ','))
  }

  /* ─── Inject add-on discounted price into #UpsellQvPriceWrapper ─── */
  // Mirrors the price display logic from upsell-product.liquid exactly:
  //   :percent with effective discount > 0 → ~~price~~ discounted_price
  //   :percent with 0% effective          → compare_at/price (existing sale) or plain price
  //   :dollar                             → ~~price~~ discounted_price
  function injectAddonDiscountPrice() {
    if (!drawerBody || !addonDiscountType) return
    var priceWrapper = drawerBody.querySelector('#UpsellQvPriceWrapper')
    if (!priceWrapper) return

    // Get current variant price/compare_at from the active swatch data attributes
    var qvEl = drawerBody.querySelector('.upsell-quick-view')
    var currentVid = qvEl ? qvEl.dataset.variantId : null
    var currentSwatch = currentVid
      ? drawerBody.querySelector('.upsell-qv-swatch[data-variant-id="' + currentVid + '"]')
      : null
    var variantPrice = currentSwatch ? parseInt(currentSwatch.dataset.variantPrice, 10) : 0
    var variantCompare = currentSwatch ? parseInt(currentSwatch.dataset.variantCompare, 10) : 0
    if (!variantPrice) return

    // Read translated labels embedded by the QV template
    var stringsEl = drawerBody.querySelector('#UpsellQvStrings')
    var labelSubtotal = stringsEl ? stringsEl.dataset.subtotal : 'SUBTOTAL'
    var labelDiscount = stringsEl ? stringsEl.dataset.addonsDiscount : 'ADD-ONS DISCOUNT'

    var finalPrice, discountedAmount

    if (addonDiscountType === ':percent') {
      var pct = addonDiscountAmount / 100.0
      discountedAmount = Math.round(variantPrice * pct)
      finalPrice = variantPrice - discountedAmount

      if (discountedAmount === 0) {
        // 0% effective discount — fall back to compare_at if available (matches upsell-product.liquid)
        // If no compare_at sale either, leave the wrapper for PDP injection
        if (variantCompare > variantPrice) {
          renderPriceBlock(priceWrapper, labelSubtotal, null, null, variantCompare, variantPrice)
        }
        return
      }
    } else if (addonDiscountType === ':dollar') {
      discountedAmount = addonDiscountAmount
      finalPrice = variantPrice - addonDiscountAmount
      if (finalPrice >= variantPrice) return
    } else {
      return
    }

    // Real discount: show discount row + strikethrough original + discounted price
    renderPriceBlock(priceWrapper, labelSubtotal, labelDiscount, discountedAmount, variantPrice, finalPrice)
  }

  function renderPriceBlock(wrapper, labelSubtotal, labelDiscount, discountedAmount, originalPrice, finalPrice) {
    var html = '<div class="grid uppercase text-xs">'

    if (labelDiscount && discountedAmount) {
      html += '<div class="flex justify-between mb-1 text-xs text-[#787878]">' +
        '<span class="font-medium uppercase tracking-wide">' + labelDiscount + '</span>' +
        '<span>- ' + formatCents(discountedAmount) + '</span>' +
        '</div>'
    }

    html += '<div class="flex items-center justify-between text-[#181D3A]">' +
      '<span class="font-bold uppercase tracking-wide">' + labelSubtotal + '</span>' +
      '<span class="flex items-baseline gap-2">'

    if (originalPrice > finalPrice) {
      html += '<span class="line-through text-sm text-[#ABABAB]">' + formatCents(originalPrice) + '</span>'
    }

    html += '<span class="text-base font-bold text-light-actions-primary">' + formatCents(finalPrice) + '</span>' +
      '</span></div></div>'

    wrapper.innerHTML = html
    wrapper.dataset.addonDiscountRendered = '1'
  }

  /* ─── Inject blocks from an already-parsed product page document ── */
  // includeAccordion = true on initial load, false on swatch changes (accordion never changes)
  function injectBlocksFromDoc(doc, includeAccordion) {
    if (includeAccordion) {
      var accordionSection = doc.querySelector(
        '[id*="section_the_only_accordion"], [class*="section_the_only_accordion"]'
      )
      var accordionWrapper = drawerBody ? drawerBody.querySelector('#UpsellQvAccordionWrapper') : null
      if (accordionSection && accordionWrapper) {
        var accordionUl = accordionSection.querySelector('ul')
        if (accordionUl) {
          // Remove Dimensions and Materials | Care — not needed in popup
          accordionUl.querySelectorAll('li').forEach(function (li) {
            var details = li.querySelector('details')
            if (details) {
              var id = details.id || ''
              if (id.indexOf('dimensions') !== -1 || id.indexOf('material_and_care') !== -1) {
                li.parentNode.removeChild(li)
              }
            }
          })
          accordionWrapper.innerHTML = accordionUl.outerHTML
          runScripts(accordionWrapper)
          accordionWrapper.querySelectorAll('.material-and-care-element').forEach(function (el) {
            el.addEventListener('click', function () {
              accordionWrapper.querySelectorAll('.material-and-care-element').forEach(function (e) {
                e.removeAttribute('aria-current')
              })
              this.setAttribute('aria-current', 'true')
            })
          })
        }
      }
    }

    // Price block — skip if JS already injected the discounted add-on price
    var priceWrapper = drawerBody ? drawerBody.querySelector('#UpsellQvPriceWrapper') : null
    if (priceWrapper && !priceWrapper.dataset.addonDiscountRendered) {
      var priceBlock = doc.querySelector('[id^="price-template--"]')
      if (priceBlock) priceWrapper.innerHTML = priceBlock.outerHTML
    }

    // Shipping estimator block
    var shippingBlock = doc.querySelector('[id^="shipping-estimator-"]')
    var shippingWrapper = drawerBody ? drawerBody.querySelector('#UpsellQvShippingWrapper') : null
    if (shippingBlock && shippingWrapper) {
      shippingWrapper.innerHTML = shippingBlock.outerHTML
    }
  }

  /* ─── Re-fetch product page on swatch change — price + shipping only ── */
  function injectFromProductPage(handle, variantId, fetchId) {
    var url = '/products/' + handle + (variantId ? '?variant=' + variantId : '')
    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status)
        return r.text()
      })
      .then(function (html) {
        if (fetchId !== swatchFetchId) return
        if (!drawerAcceptsInjectedContent()) return
        var parser = new DOMParser()
        injectBlocksFromDoc(parser.parseFromString(html, 'text/html'), false)
        // Re-apply addon discount after PDP injection (which may have reset price wrapper)
        injectAddonDiscountPrice()
      })
      .catch(function (err) {
        console.warn('[upsell-qv] product page fetch failed:', err)
      })
  }

  /* ─── Collect add-on handles from the bundle page ────────────── */
  // Returns the handles of all products that have a quick-view trigger on the
  // current page — these are the add-ons the bundle considers optional.
  function getPageAddonHandles() {
    var handles = []
    document.querySelectorAll('[data-upsell-qv-handle]').forEach(function (el) {
      var h = el.dataset.upsellQvHandle
      if (h && handles.indexOf(h) === -1) handles.push(h)
    })
    return handles
  }

  function syncSwatchActiveState(variantId) {
    if (!drawerBody || !variantId) return
    drawerBody.querySelectorAll('.upsell-qv-swatch').forEach(function (s) {
      if (s.dataset.variantId === variantId) s.setAttribute('data-upsell-active', '')
      else s.removeAttribute('data-upsell-active')
    })
  }

  /* ─── Re-compute swatch availability using bundle-page context ── */
  // Shopify's variant.available can be contaminated when a shared component
  // (e.g. chairs ASB) is OOS.  The quick-view template embeds the raw
  // component data (#UpsellQvComponentData).  We cross-reference it against
  // the bundle page's known add-on handles so that an OOS add-on never marks
  // a sibling add-on's swatch as sold-out.
  function recalcSwatchAvailability() {
    if (!drawerBody) return
    var dataEl = drawerBody.querySelector('#UpsellQvComponentData')
    if (!dataEl) return

    var componentData
    try { componentData = JSON.parse(dataEl.textContent) }
    catch (e) { console.warn('[upsell-qv] component data parse error:', e); return }

    var addonHandles = getPageAddonHandles()

    drawerBody.querySelectorAll('.upsell-qv-swatch').forEach(function (btn) {
      var variantId = btn.dataset.variantId
      var varData = componentData[variantId]
      if (!varData) return

      var ps = varData.progress_bar_sets   // null = blank = in stock; 0 = OOS
      var comps = varData.components || []
      var isAvailable

      if (ps === 0) {
        // progress_bar_sets = 0 → sold out (store's real OOS flag)
        isAvailable = false
      } else if (comps.length > 0) {
        // Bundle product: check components, skip add-on products
        isAvailable = true
        for (var i = 0; i < comps.length; i++) {
          var comp = comps[i]
          if (!comp.available && addonHandles.indexOf(comp.handle) === -1) {
            isAvailable = false
            break
          }
        }
      } else {
        // Single product, no components: null/positive progress_bar_sets = in stock
        isAvailable = (ps !== 0)  // null !== 0 → true
      }

      btn.dataset.variantAvailable = isAvailable ? 'true' : 'false'
    })

    // Re-sync badge + ATC for the currently-displayed variant
    var qvEl = drawerBody.querySelector('.upsell-quick-view')
    var currentVid = qvEl ? qvEl.dataset.variantId : null
    if (!currentVid) return
    var currentBtn = drawerBody.querySelector('.upsell-qv-swatch[data-variant-id="' + currentVid + '"]')
    if (!currentBtn) return

    var available = currentBtn.dataset.variantAvailable === 'true'
    var shipDays = parseInt(currentBtn.dataset.variantShippingDays, 10) || 14

    var badgeEl = drawerBody.querySelector('#UpsellQvBadge')
    var outStockEl = drawerBody.querySelector('#UpsellQvOutOfStock')
    if (badgeEl) {
      if (available && shipDays <= 20) badgeEl.removeAttribute('hidden')
      else badgeEl.setAttribute('hidden', '')
    }
    if (outStockEl) outStockEl.setAttribute('hidden', '')

    var atcBtn = drawerBody.querySelector('#UpsellQvAddToCart')
    if (atcBtn) {
      atcBtn.disabled = !available
      atcBtn.textContent = available
        ? (atcBtn.dataset.atcText || 'Add to cart')
        : (atcBtn.dataset.soldOutText || 'Sold out')
    }

    syncSwatchActiveState(currentVid)
  }

  /* ─── Gallery: load slides from <template> + init Swiper ─────── */
  function switchGallery(variantId) {
    destroySwipers()

    var mainWrapper = drawerBody.querySelector('#UpsellQvMainWrapper')
    var thumbsWrapper = drawerBody.querySelector('#UpsellQvThumbsWrapper')
    if (!mainWrapper) return

    // Clone slides from the matching <template> elements
    var mainTpl = drawerBody.querySelector('template[data-upsell-main="' + variantId + '"]')
    var thumbsTpl = drawerBody.querySelector('template[data-upsell-thumbs="' + variantId + '"]')

    if (mainTpl) {
      mainWrapper.innerHTML = ''
      mainWrapper.appendChild(mainTpl.content.cloneNode(true))
    }
    if (thumbsWrapper && thumbsTpl) {
      thumbsWrapper.innerHTML = ''
      thumbsWrapper.appendChild(thumbsTpl.content.cloneNode(true))
    }

    initGallery()
  }

  function initGallery() {
    var mainEl = drawerBody.querySelector('#UpsellQvMain')
    var thumbsEl = drawerBody.querySelector('#UpsellQvThumbs')
    if (!mainEl || typeof Swiper === 'undefined') return

    var thumbSlides = thumbsEl ? thumbsEl.querySelectorAll('.swiper-slide') : []

    if (thumbsEl && thumbSlides.length > 1) {
      swiperThumbs = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          prevEl: thumbsEl.querySelector('.upsell-qv-thumb-btn--prev'),
          nextEl: thumbsEl.querySelector('.upsell-qv-thumb-btn--next'),
        },
      })
    }

    swiperMain = new Swiper(mainEl, {
      spaceBetween: 0,
      loop: false,
      thumbs: swiperThumbs ? { swiper: swiperThumbs } : undefined,
      on: {
        slideChange: function () { updateActiveThumbnail(swiperMain.activeIndex) },
      },
    })

    // Thumbnail click → jump to main slide
    if (thumbsEl) {
      thumbsEl.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
        slide.addEventListener('click', function () {
          if (swiperMain) swiperMain.slideTo(i)
        })
      })
    }

    updateActiveThumbnail(0)
  }

  function updateActiveThumbnail(activeIdx) {
    var thumbsEl = drawerBody ? drawerBody.querySelector('#UpsellQvThumbs') : null
    if (!thumbsEl) return
    thumbsEl.querySelectorAll('.swiper-slide').forEach(function (slide, i) {
      if (i === activeIdx) slide.setAttribute('data-upsell-thumb-active', '')
      else slide.removeAttribute('data-upsell-thumb-active')
    })
  }

  function destroySwipers() {
    if (swiperMain) { try { swiperMain.destroy(true, true) } catch (e) {} ; swiperMain = null }
    if (swiperThumbs) { try { swiperThumbs.destroy(true, true) } catch (e) {} ; swiperThumbs = null }
  }

  /* ─── Swatch clicks — update only changed parts ──────────────── */
  function bindSwatchClicks() {
    if (!drawerBody) return
    var qvEl = drawerBody.querySelector('.upsell-quick-view')
    var handle = qvEl ? qvEl.dataset.handle : null

    drawerBody.querySelectorAll('.upsell-qv-swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId
        var available = btn.dataset.variantAvailable === 'true'
        var shippingDays = parseInt(btn.dataset.variantShippingDays, 10) || 14

        // 1. Gallery
        switchGallery(variantId)

        // 2. Active swatch (data-upsell-active → CSS in _upsell-quick-view.css)
        syncSwatchActiveState(variantId)

        // 3. Finish name
        var finishEl = drawerBody.querySelector('#UpsellQvVariantTitle')
        if (finishEl) finishEl.textContent = btn.dataset.variantTitle

        // 4. Availability badge — hide both when OOS (product page behaviour)
        var badgeEl = drawerBody.querySelector('#UpsellQvBadge')
        var outStockEl = drawerBody.querySelector('#UpsellQvOutOfStock')
        if (badgeEl) {
          if (available && shippingDays <= 20) badgeEl.removeAttribute('hidden')
          else badgeEl.setAttribute('hidden', '')
        }
        if (outStockEl) outStockEl.setAttribute('hidden', '')

        // 5. "See Full Details" + share URL — keep variant param in sync
        var qvRoot = drawerBody.querySelector('.upsell-quick-view')
        if (qvRoot) qvRoot.dataset.variantId = variantId
        var fullDetailsLink = drawerBody.querySelector('#UpsellQvFullDetailsLink')
        if (fullDetailsLink) {
          var pu = qvRoot && qvRoot.dataset.productUrl ? qvRoot.dataset.productUrl : ''
          if (typeof window.buildProductShareUrl === 'function') {
            fullDetailsLink.href = window.buildProductShareUrl(pu, variantId, null)
          } else {
            fullDetailsLink.href = fullDetailsLink.href.replace(/(\?variant=)\d+/, '$1' + variantId)
          }
          if (typeof window.updateShareButtonUrl === 'function') {
            var hasShare =
              drawerBody.querySelector('product-share[data-share-section="upsell-quick-view"]') ||
              drawerBody.querySelector('#Share-upsell-quick-view')
            if (hasShare) window.updateShareButtonUrl('Share-upsell-quick-view', fullDetailsLink.href)
          }
        }

        // 6. Add to cart button
        var atcBtn = drawerBody.querySelector('#UpsellQvAddToCart')
        if (atcBtn) {
          atcBtn.dataset.variantId = variantId
          atcBtn.disabled = !available
          atcBtn.textContent = available
            ? (atcBtn.dataset.atcText || 'Add to cart')
            : (atcBtn.dataset.soldOutText || 'Sold out')
        }

        // 7. Price + shipping — re-fetch from product page for this variant
        // Accordion is variant-agnostic; skip it on swatch change for speed
        if (handle) {
          var fetchId = ++swatchFetchId
          injectFromProductPage(handle, variantId, fetchId)
        }
      })
    })
  }

  function getUpsellQuickViewAddQuantity() {
    var root = drawerBody ? drawerBody.querySelector('.upsell-quick-view') : null
    if (root && root.getAttribute('data-upsell-qv-even-qty-only') === 'true') return 2
    return 1
  }

  /* ─── Add to cart ────────────────────────────────────────────── */
  function bindAddToCart() {
    var btn = drawerBody ? drawerBody.querySelector('#UpsellQvAddToCart') : null
    if (!btn) return

    btn.addEventListener('click', function () {
      if (btn.disabled) return
      var variantId = btn.dataset.variantId
      if (!variantId) return

      var qty = getUpsellQuickViewAddQuantity()
      var atcText = btn.dataset.atcText || 'Add to cart'
      btn.disabled = true
      btn.setAttribute('data-upsell-atc-loading', '')
      btn.textContent = qty > 1 ? 'Adding ' + qty + '\u2026' : 'Adding\u2026'

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: String(variantId),
              quantity: qty,
              properties: CART_LINE_PROPERTIES_UPSELL_DRAWER,
            },
          ],
        }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || 'Error adding to cart')
            return data
          })
        })
        .then(function () {
          refreshCartDrawer()
          btn.removeAttribute('data-upsell-atc-loading')
          btn.textContent = '\u2713 Added to cart'
          setTimeout(function () {
            btn.textContent = atcText
            btn.disabled = false
            closeDrawer()
          }, 2200)
        })
        .catch(function (err) {
          console.error('[upsell-qv] add to cart:', err)
          btn.removeAttribute('data-upsell-atc-loading')
          btn.textContent = atcText
          btn.disabled = false
        })
    })
  }

  function updateHeaderCartBubbleFromCart(bubbleEl, cart) {
    if (!bubbleEl) return
    var countEl = bubbleEl.querySelector('[data-upsell-qv="cart-count"]') || bubbleEl.querySelector('div')
    var count = cart.item_count
    if (count > 0) {
      if (countEl) countEl.textContent = count
      else {
        var el = document.createElement('div')
        el.setAttribute('data-upsell-qv', 'cart-count')
        el.textContent = count
        bubbleEl.appendChild(el)
      }
    } else if (countEl) {
      countEl.remove()
    }
  }

  // Refresh the cart drawer content silently (without opening it) so the
  // drawer shows the newly-added item when the customer clicks the cart icon.
  function refreshCartDrawer() {
    var cartDrawerEl = document.querySelector('cart-drawer')
    if (!cartDrawerEl || typeof cartDrawerEl.getSectionsToRender !== 'function') {
      // Fallback: update mobile + desktop header bubbles (see header.liquid / header-desktop.liquid)
      fetch('/cart.js')
        .then(function (r) { return r.json() })
        .then(function (cart) {
          updateHeaderCartBubbleFromCart(document.getElementById('cart-icon-bubble'), cart)
          updateHeaderCartBubbleFromCart(document.getElementById('cart-icon-bubble-desktop'), cart)
        })
        .catch(function () {})
      return
    }

    var sections = cartDrawerEl.getSectionsToRender().map(function (s) { return s.id }).join(',')
    var cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart'
    fetch(cartUrl + '?sections=' + sections)
      .then(function (r) { return r.json() })
      .then(function (sectionsData) {
        // Update each section's DOM without calling open() on the cart drawer
        cartDrawerEl.getSectionsToRender().forEach(function (section) {
          var el = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id)
          if (!el || !sectionsData[section.id]) return
          var parsed = new DOMParser().parseFromString(sectionsData[section.id], 'text/html')
          var inner = parsed.querySelector(section.selector || '.shopify-section')
          if (inner) el.innerHTML = inner.innerHTML
        })
        // After innerHTML replacement, the cart overlay element is a new node —
        // re-attach the close handler so clicking the overlay still closes the drawer.
        setTimeout(function () {
          var cartOverlay = cartDrawerEl.querySelector('#CartDrawer-Overlay')
          if (cartOverlay && typeof cartDrawerEl.closeHandler === 'function') {
            cartOverlay.removeEventListener('click', cartDrawerEl.closeHandler)
            cartOverlay.addEventListener('click', cartDrawerEl.closeHandler)
          }
          if (typeof cartDrawerEl.initializeUpsellButtons === 'function') {
            cartDrawerEl.initializeUpsellButtons()
          }
        })
      })
      .catch(function () {})
  }

  /* ─── Swipe-down to close (mobile) ───────────────────────────── */
  function setupSwipeToClose() {
    var touchStartY = 0
    var touchCurrentY = 0
    var isDragging = false
    var isMobile = function () { return window.innerWidth < 640 }

    drawer.addEventListener('touchstart', function (e) {
      if (!isMobile() || (drawerBody && drawerBody.scrollTop > 0)) return
      touchStartY = e.touches[0].clientY
      isDragging = true
    }, { passive: true })

    drawer.addEventListener('touchmove', function (e) {
      if (!isDragging || !isMobile()) return
      touchCurrentY = e.touches[0].clientY
      var deltaY = touchCurrentY - touchStartY
      if (deltaY > 0) {
        drawer.style.transition = 'none'
        drawer.style.transform = 'translateY(' + deltaY + 'px)'
      }
    }, { passive: true })

    drawer.addEventListener('touchend', function () {
      if (!isDragging) return
      isDragging = false
      var deltaY = touchCurrentY - touchStartY
      drawer.style.transition = ''
      drawer.style.transform = ''
      if (deltaY > 80 && isMobile()) closeDrawer()
      touchStartY = 0
      touchCurrentY = 0
    })
  }

  /* ─── Click delegation — image trigger ───────────────────────── */
  function openQuickViewFromTrigger(trigger) {
    if (!trigger || !trigger.dataset.upsellQvHandle) return
    var variantId = trigger.dataset.upsellQvVariant || ''
    var bundleItem = trigger.closest('bundle-item')
    if (bundleItem && bundleItem.dataset.currentVariant) {
      variantId = bundleItem.dataset.currentVariant
    }
    // Capture add-on discount context from the bundle page trigger
    addonDiscountType = trigger.dataset.upsellQvDiscountType || ''
    addonDiscountAmount = parseFloat(trigger.dataset.upsellQvDiscountAmount) || 0
    fetchAndShow(
      trigger.dataset.upsellQvHandle,
      variantId,
      trigger.dataset.upsellQvTitle || trigger.dataset.upsellQvHandle
    )
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-upsell-qv-handle]')
    if (!trigger) return
    e.preventDefault()
    e.stopPropagation()
    openQuickViewFromTrigger(trigger)
  })

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return
    var trigger = e.target.closest('[data-upsell-qv-handle]')
    if (!trigger) return
    // Native button/link (or trigger is one): Enter/Space also fires click — let click handler run once
    if (trigger.matches('button, a[href], [role="button"]')) return
    if (e.target.closest('button, a[href], [role="button"]')) return
    e.preventDefault()
    e.stopPropagation()
    openQuickViewFromTrigger(trigger)
  })

  /* ─── Init ────────────────────────────────────────────────────── */
  function init() {
    injectDrawer()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()